import React, {useMemo, useCallback} from 'react';
import InRangeSelect from 'components/common/form/select/InRangeSelect';
import {useFormContext} from 'react-hook-form';
import {isLenderCredit} from 'lib/product';
import {useHomeSafeStandardMetricsQuery} from 'query/products/home-safe/homesafe-standard-metrics';
import {useTranslation} from 'lib/i18n';

TierRatesSelect.propTypes = {};

function TierRatesSelect(props) {
  const {defaultValue: defValue, ...rest} = props;
  const {t} = useTranslation();

  const {watch} = useFormContext();
  const [Lesa, LenderCredit] = watch(['Lesa', 'LenderCredit']);
  const [StateValue] = watch(['State']);
  const [ProductId] = watch(['ProductId']);

  const {data: tiers = [], defaultTier} = useHomeSafeStandardMetricsQuery({
    ProductId: ProductId,
    State: StateValue,
  });

    var getTierLabel = useCallback(
        (tier = {}, lenderCreditOptions = {}) => {
          let {Rate = 0, OriginationFee = 0, Name = ''} = tier;
          const Fee = OriginationFee * 100;
  
          if (isLenderCredit(lenderCreditOptions)) {
            Rate = tier.LenderCredit;
          }
  
          return t('inputsTranslation:HomeSafeMetricId.valueFormat', {
            Name: Name.replace('_', ' '),
            Rate,
            count: Fee,
          });
        },
        [t],
      );

  const defaultValue = useMemo(
    () => defValue ?? defaultTier?.HomeSafeMetricId,
    [defValue, defaultTier?.HomeSafeMetricId],
  );

  const data = useMemo(
    () =>
      tiers
        .filter((tier) => (isLenderCredit({Lesa, LenderCredit}) ? tier.LenderCredit > 0 : true))
        .map((tier) => ({
          value: tier.HomeSafeMetricId,
          label: getTierLabel(tier, {Lesa, LenderCredit}),
          selected: tier.HomeSafeMetricId === defaultValue,
        })),
    [tiers, defaultValue, getTierLabel, Lesa, LenderCredit, StateValue],
  );

  return <InRangeSelect {...rest} options={data} defaultValue={defaultValue} />;
}

export default TierRatesSelect;
